import z from 'zod'

import { OutletDto } from '@/features/outlet'

import { zh } from '@/libs/utils/zod'

export const AccountRole = z.enum(['manager', 'staff'])
export const AccountStatus = z.enum(['active', 'inactive'])

export type AccountRole = z.infer<typeof AccountRole>
export type AccountStatus = z.infer<typeof AccountStatus>

export const AccountDto = z.object({
  name: z.string(),
  username: z.string(),
  email: z.string(),
  status: AccountStatus,
  pin: z.string(),
  isRoot: z.boolean(),
  outlets: z.array(
    z.object({
      role: AccountRole,
      oId: z.string(),
      isDefault: z.boolean(),
      outlet: OutletDto,
    })
  ),
  ...zh.metadata.shape,
})

export type AccountDto = z.infer<typeof AccountDto>

export const AccountSelectDto = z.object({
  ...AccountDto.pick({
    id: true,
    name: true,
    username: true,
    email: true,
    status: true,
    pin: true,
    isRoot: true,
    createdAt: true,
    createdBy: true,
    updatedAt: true,
    updatedBy: true,
  }).shape,
})

export type AccountSelectDto = z.infer<typeof AccountSelectDto>
